import React from 'react';
import { Star } from 'lucide-react';
export function ResultsSection() {
  const benefits = ['Despertarte más liviana — sin panza hinchada apenas abrís los ojos', 'Menos inflamación visible — desde las primeras semanas del plan', 'Menos ganas de dulce — sin luchar, sin prohibirte, sin fuerza de voluntad', 'Digestión más tranquila y predecible — tu cuerpo funciona con vos, no contra vos', 'Más energía física y mental — para tu día, tus hijos, tu trabajo, tu vida', 'Volver a disfrutar la comida sin culpa — comer rico y sentirte bien al mismo tiempo'];
  return <section className="py-20 bg-stone-100" data-id="element-265">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-266">
        <div className="max-w-6xl mx-auto" data-id="element-267">
          <div className="text-center mb-16" data-id="element-268">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-269">
              Esto es lo que vas a empezar a sentir
            </h2>
            <p className="text-xl text-emerald-700 font-serif italic" data-id="element-270">
              No en meses. En semanas. Algunos desde los primeros días.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-id="element-271">
            {benefits.map((benefit, idx) => <div key={idx} className="bg-white p-8 rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 border border-stone-200/50" data-id="element-272">
                <div className="mb-4" data-id="element-273">
                  <Star className="w-8 h-8 text-yellow-400 fill-yellow-400" data-id="element-274" />
                </div>
                <p className="text-gray-800 font-medium leading-relaxed" data-id="element-275">
                  {benefit}
                </p>
              </div>)}
          </div>

          <div className="text-center" data-id="element-276">
            <h3 className="text-2xl md:text-3xl font-serif italic text-gray-800" data-id="element-277">
              "Dejar de pelear con tu cuerpo… y empezar a sentir que juega a tu
              favor."
            </h3>
          </div>
        </div>
      </div>
    </section>;
}